import label from "@/lang/StaticLabels.js";

export default {
  token: null,
  loginCheck: false,
  forgotCheck: false,
  forgotBtn: false,
  workspaceStep: false,
  workspaceLoading: false,
  userProfile: {},

  postCheck: false,
  postCheck2: false,
  postCheckHeader: false,
  postCheckFiscalYear: false,
  checkAlert: 0,
  successMessage: null,
  warningMessage: null,
  infoMessage: null,
  dangerMessage: null,

  loadingCheck: 0,
  loadingMessage: label.caption.loading,

  loadingBtn: false,
  updateModule: 1,

  userSession: [],

  errorMessage: [],
  modalVisibility: false,

  breadcrumbs: [],

  themeMode: "default",
  themeColor: "green",

  tabsData: {},
  activeTabs: [],

  // Static Data ---------------------------------------------------------------
  cartableIds: {
    buyRequest: "1",
    receipt: "2",
    draft: "3",
    voucher: "5",
    receiveCheque: "6",
    paymentRequest: "7",
    paymentCheque: "8",
    sale: "9",
    saleReturn: "10",
    buy: "11",
    buyReturn: "12",
    produceOrder: "13",
    advance: "18",
    leave: "19",
    order: "20",
    mission: "21",
  },

  subSystems: {
    file: "1",
    notify: "2",
    base: "10",
    acnt: "11",
    bank: "12",
    fund: "13",
    aset: "14",
    bdgt: "15",
    cafm: "16",
    taxs: "17",
    ordr: "18",
    sale: "19",
    afs: "20",
    club: "21",
    parak: "22",
    scms: "23",
    whrs: "24",
    lgst: "25",
    hrms: "26",
    edu: "27",
    salary: "28",
    prs: "29",
    pms: "30",
    pmis: "31",
    mrp: "32",
    mrp2Al: "33",
    mrp2Valves: "34",
    opcs: "35",
    qcms: "36",
    mnet: "37",
    de: "38",
    kms: "39",
    bpms: "40",
    bi: "41",
    ofic: "42",
    hamsaz: "43",
    hamyar: "44",
  },

  attachmentType: {
    voucher: "Voucher",
    payment: "Payment",
    receiveCheque: "ReceiveCheque",
    receiveCash: "ReceiveCash",
    paymentCheque: "PaymentCheque",
    cashPayment: "CashPayment",
    buyFactor: "BuyFactor",
    returnBuyFactor: "ReturnBuyFactor",
    draft: "Draft",
    draftCartable: "DraftCartable",
    receipt: "Receipt",
    receiptCartable: "ReceiptCartable",
    order: "Order",
    orderCartable: "OrderCartable",
    receive: "Receive",
    tempReceipt: "TempReceipt",
    draftRequest: "DraftRequest",
    draftRequestCartable: "DraftRequestCartable",
    transferCommodity: "TransferCommodity",
    processTransferCommodity: "ProcessTransferCommodity",
    processTransferCommodityCartable: "ProcessTransferCommodityCartable",
    commodityConversion: "CommodityConversion",
    warehousing: "Warehousing",
    commodity: "Commodity",
    commodityImage: "CommodityImage",
    preFactor: "PreFactor",
    saleFactor: "SaleFactor",
    returnSaleFactor: "ReturnSaleFactor",
    orderOrderCommodityMulti: "Order_OrderCommodity_Multi",
    mrpValvsOrder: "MrpValvsOrder",
    mrp2ValvesOrderCommodityMulti: "Mrp2ValvesOrder_OrderCommodity_Multi",
    mrp2ValvesCommodityAdditionalInfo: "Mrp2ValvesCommodityAdditionalInfo",
    buyRequest: "ReqBuy",
    bankTransfer: "BankTransfer",
    suite: "Suite",
    costEstimate: "CostEstimate",
    hamsazProject: "HamsazProject",
    hamyarProject: "HamyarProject",
    meeting: "Meeting",
    task: "Task",
    participation: "Participation",
    branchTaxCertificate: "Branch_TaxCertificate",
  },
};
